export default "__VITE_ASSET__CoHPo3JC__"